import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * react-router v6 removed withRouter. This shim injects the v5-shaped props the
 * class components still read. `history.push/replace` accept both v5 forms:
 * push('/path'), push({ pathname, search, state }) — state embedded in the
 * location object is unwrapped into v6's options argument.
 */
export default function withRouter(WrappedComponent) {
    return function WithRouterWrapper(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const normalise = (to, state, replace) => {
            if (to && typeof to === 'object' && to.state !== undefined) {
                const { state: embeddedState, ...rest } = to;
                navigate(rest, { state: embeddedState, replace });
            } else {
                navigate(to, { state, replace });
            }
        };

        const history = {
            push: (to, state) => normalise(to, state, false),
            replace: (to, state) => normalise(to, state, true),
            goBack: () => navigate(-1),
            location,
        };

        return (
            <WrappedComponent
                {...props}
                history={history}
                location={location}
                match={{ params }}
                navigate={navigate}
                params={params}
            />
        );
    };
}
